import { c as create_ssr_component } from "./ssr.js";
const Wrapper_svelte_svelte_type_style_lang = "";
const css = {
  code: ".main.svelte-sugxaq{display:flex;flex-direction:column;gap:5rem;padding:10rem 13rem}@media screen and (max-width: 768px){.main.svelte-sugxaq{padding:5rem 2rem;gap:2rem}}",
  map: null
};
const Wrapper = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  $$result.css.add(css);
  return `<div class="main svelte-sugxaq">${slots.default ? slots.default({}) : ``} </div>`;
});
export {
  Wrapper as W
};
